// extracted by mini-css-extract-plugin
module.exports = {"individuBotoInserir":"Individu_individuBotoInserir__RZKeR","individuSpinner":"Individu_individuSpinner__bSVh2"};